import { Component } from "react";
import { toast, ToastContainer } from "react-toastify";
import LayoutWrapper from "./LayoutWrapper";

export class MyProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editData: {},
      errorMessage: { name: "", message: "" },
      loader: false,
      formFields: [
        {
          type: "text",
          name: "full_name",
          label: "Name",
          required: true,
        },
        {
          type: "text",
          name: "phone_number",
          label: "Mobile Number ",
          pattern: "[0-9]{10}",
          onBlur: (e) => this.handleMobileNo(e),
          disabled: true,
        },
        {
          type: "text",
          name: "email_address",
          label: "Email ID",
          required: true,
        },
        {
          type: "file",
          fileType: "package",
          uploadType: "public",
          name: "profile_picture",
          label: "Image",
          accept: "image/*",
          placeholder: "Upload here",
          required: true,
        },
        {
          type: "textarea",
          name: "address",
          label: "Address",
          customcolspan: "8",
          required: true,
        },
        {
          type: "text",
          name: "child_name",
          label: "Child Name",
          required: true,
        },
        {
          type: "select",
          name: "grade",
          label: "Grade",
          options: [],
          required: true,
        },
        {
          type: "text",
          name: "school_name",
          label: "School Name",
          required: true,
        },
        {
          type: "text",
          name: "school_city",
          label: "School City",
          required: true,
        },
      ],
    };
  }

  componentDidMount() {
    this.props.api.apiGetB2cUser().then(({ data }) => {
      if (data) {
        let updatedFields = this.state.formFields?.map((item) => {
          return {
            ...item,
            defaultValue: data[item.name],
          };
        });
        console.log({ data });
        this.props.setstore("user", {
          ...window.store.getState().root.user,
          child_name: data?.child_name,
        });

        this.setState({ editData: data, formFields: updatedFields });
        this.getGrades();
      }
    });
  }

  getGrades() {
    this.props.api.apiGetCurriculumGrades().then((res) => {
      let gradeOpts = res.data?.options("curriculum_grade", "curriculum_grade");
      if (res) {
        let updatedFields = this.state.formFields?.map((item) => {
          if (item?.name === "grade") {
            return {
              ...item,
              options: gradeOpts,
            };
          } else {
            return item;
          }
        });
        this.setState({ formFields: updatedFields });
      }
    });
  }

  handleMobileNo(e) {
    let Value = e.target.value;
    const urlRegex = /^[0]?[789]\d{9}$/;
    if (!urlRegex.test(Value)) {
      this.setState({
        errorMessage: {
          name: "phone_number",
          message: "Please enter valid contact number",
        },
      });
    } else {
      this.setState({
        errorMessage: {
          name: "",
          message: "",
        },
      });
    }
  }
  updateMyProfile(event, data) {
    console.log({ editData: data });
    let updatePayload = {
      ...data,
    };

    this.props.api
      .apiUpdateB2cUser(updatePayload)
      .then((res) => {
        this.setState({
          loader: false,
        });
        toast.success("Profile Updated Successfully", {
          autoClose: 3000,
          closeButton: false,
          hideProgressBar: true,
        });

        this.props.setstore("user", {
          ...window.store.getState().root.user,
          child_name: data?.child_name,
        });
        this.props.navigate("/dashboard");
      })
      .catch((err) => {
        this.setState({
          loader: false,
        });
      });
  }

  render() {
    let { navigate } = this.props;
    let { loader, errorMessage, formFields } = this.state;
    return (
      <>
        {loader && (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        )}
        <LayoutWrapper title="Profile" back="">
          <ToastContainer position="top-right" />

          <AppForm
            className="flex flex-col gap-4 bg-white p-4"
            onSubmit={(...args) => this.updateMyProfile(...args)}
          >
            <div className="row">
              {formFields?.map((field, i) => (
                <div
                  className={
                    field.fieldclass
                      ? field.fieldclass
                      : `col-12 col-md-6 col-lg-${field.customcolspan || 4}`
                  }
                  key={"field" + i}
                >
                  <AppInput {...field} />
                  {errorMessage.name == field.name && (
                    <label className="invalid-feedback">
                      {this.state.errorMessage.message}
                    </label>
                  )}
                </div>
              ))}
            </div>
            <div className="row no-gutters pb-2 pt-4 pe-2">
              <>
                <button
                  type="button"
                  onClick={(...args) => navigate("/dashboard")}
                  className="btn close-btn col col-md-1 ml-auto rounded-1 text-dark "
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn save-btn col col-md-1 ml-auto ms-2 me-2 rounded-1"
                >
                  Update
                </button>
              </>
            </div>
          </AppForm>
        </LayoutWrapper>
      </>
    );
  }
}

export default connect(MyProfile);
